import React, { createContext, useContext, useState, useCallback } from 'react';

const STORAGE_KEY = 'em_theme';

export const DEFAULTS = {
  colorPrimary:  '#f59e0b',
  borderRadius:  8,
  mode:          'light',   // 'light' | 'dark'
  sidebarStyle:  'dark',    // 'dark' | 'light' | 'colored'
};

const load = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? { ...DEFAULTS, ...JSON.parse(raw) } : { ...DEFAULTS };
  } catch {
    return { ...DEFAULTS };
  }
};

export const ThemeContext = createContext({
  theme:    DEFAULTS,
  setTheme: () => {},
});

export const ThemeProvider = ({ children }) => {
  const [theme, setThemeState] = useState(load);

  const setTheme = useCallback((partial) => {
    setThemeState(prev => {
      const next = { ...prev, ...partial };
      localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
      return next;
    });
  }, []);

  return (
    <ThemeContext.Provider value={{ theme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
